import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../supabase';
import { getUser } from '../auth';

export default function NavBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = getUser();
  const [notifCount, setNotifCount] = useState(0);

  useEffect(() => {
    if (!user) return;
    fetchNotifs();
    const channel = supabase
      .channel('notifs-' + user.id)
      .on('postgres_changes', {
        event: 'INSERT',
        schema: 'public',
        table: 'notifications',
        filter: `user_id=eq.${user.id}`
      }, () => fetchNotifs())
      .subscribe();
    return () => supabase.removeChannel(channel);
  }, [user?.id]);

  const fetchNotifs = async () => {
    if (!user) return;
    const { data } = await supabase
      .from('notifications')
      .select('*')
      .eq('user_id', user.id)
      .eq('lu', false);
    setNotifCount(data?.length || 0);
  };

  const hideOn = ['/', '/inscription', '/connexion', '/creer'];
  if (hideOn.includes(location.pathname)) return null;

  const items = [
    { path: '/feed', icon: '🏠', label: 'Accueil' },
    { path: '/carte', icon: '🗺️', label: 'Carte' },
    { path: '/creer', icon: null, label: 'Créer', special: true },
    { path: '/profil', icon: '👤', label: 'Profil', badge: notifCount },
  ];

  return (
    <>
      <style>{`
        @keyframes navPop { 0%{transform:scale(0.9)} 50%{transform:scale(1.08)} 100%{transform:scale(1)} }
      `}</style>
      <div style={{
        position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
        width: '100%', maxWidth: 420, zIndex: 300,
        background: 'white',
        borderTop: '1px solid #F0F5F1',
        paddingBottom: 'env(safe-area-inset-bottom, 16px)',
        display: 'flex', justifyContent: 'space-around', alignItems: 'center',
        boxShadow: '0 -4px 24px rgba(28,43,30,0.1)',
      }}>
        {items.map((item, i) => {
          const isActive = location.pathname === item.path;

          if (item.special) return (
            <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 8, paddingBottom: 8 }}>
              <button onClick={() => navigate(item.path)} style={{
                width: 54, height: 54, borderRadius: '50%',
                background: 'linear-gradient(135deg, #FF7043, #FF5722)',
                border: 'none', cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: '0 4px 16px rgba(255,112,67,0.5)',
                transform: 'translateY(-12px)',
                fontSize: '1.5rem', color: 'white', fontWeight: 900,
              }}>
                ＋
              </button>
            </div>
          );

          return (
            <button key={i} onClick={() => navigate(item.path)} style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center',
              gap: 4, background: 'none', border: 'none', cursor: 'pointer',
              padding: '10px 20px 8px', position: 'relative', flex: 1,
              animation: isActive ? 'navPop 0.3s ease' : 'none',
            }}>
              <div style={{ position: 'relative' }}>
                {/* Fond actif */}
                {isActive && (
                  <div style={{
                    position: 'absolute', inset: -8, borderRadius: 14,
                    background: '#EDF7F1',
                    zIndex: 0,
                  }} />
                )}
                <div style={{ fontSize: '1.3rem', position: 'relative', zIndex: 1, filter: isActive ? 'none' : 'grayscale(0.4) opacity(0.6)' }}>
                  {item.icon}
                </div>
                {item.badge > 0 && (
                  <div style={{
                    position: 'absolute', top: -6, right: -8, zIndex: 2,
                    width: 17, height: 17, borderRadius: '50%',
                    background: '#FF7043', color: 'white',
                    fontSize: '0.58rem', fontWeight: 900,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    border: '2px solid white',
                    boxShadow: '0 2px 8px rgba(255,112,67,0.4)',
                  }}>
                    {item.badge > 9 ? '9+' : item.badge}
                  </div>
                )}
              </div>
              <div style={{
                fontSize: '0.62rem', fontWeight: isActive ? 800 : 600,
                color: isActive ? '#3D9A6A' : '#B0C4B8',
                fontFamily: 'Nunito, sans-serif',
                transition: 'all 0.2s',
              }}>
                {item.label}
              </div>
            </button>
          );
        })}
      </div>
    </>
  );
}